<template>
  <div :id="identification" class="scroll-text-section text-block" :style="myBlockProps.getStyles(visible)">
    <span :style="myTextProps.getStyles()">{{ myText.getText(selectedLanguage) }}</span>
  </div>
</template>

<script>
import TextBlock from './TextBlock.vue';

export default {
  name: 'text-block',
  extends: TextBlock,
};
</script>
